/**
 * @generated SignedSource<<4abaf3e73a42e763cec8f18a69f2deb9>>
 * @relayHash 6d284c4e2738019b6564014da1145298
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f02b9eff7aa36cbdef2d023444ef3574a2ca29a78d05ea41986c50fe24bbf5e7

import type { ConcreteRequest } from 'relay-runtime';
export type AppNetworkEgressCategoryExtension = "ANALYTICS" | "%future added value";
export type AppNetworkPermissionTypeExtension = "FETCH_BACKEND_SIDE" | "FETCH_CLIENT_SIDE" | "FONTS" | "FRAMES" | "IMAGES" | "MEDIA" | "NAVIGATION" | "SCRIPTS" | "STYLES" | "%future added value";
export type CapabilitySet = "capabilityAdvanced" | "capabilityStandard" | "%future added value";
export type DataClassificationPolicyDecisionStatus = "ALLOWED" | "BLOCKED" | "%future added value";
export type EcosystemLicenseMode = "USER_ACCESS" | "%future added value";
export type ExtensionContextsFilterType = "APP_ID_ENVIRONMENT_ID" | "DATA_CLASSIFICATION_TAG" | "DEFINITION_ID" | "EXTENSION_TYPE" | "PRINCIPAL_TYPE" | "%future added value";
export type ExtensionContextsFilter = {
  type: ExtensionContextsFilterType;
  value: ReadonlyArray<string>;
};
export type getForgeUIExtensionsAsync_Query$variables = {
  contextIds: ReadonlyArray<string>;
  dataClassificationTags: ReadonlyArray<string>;
  filter: ReadonlyArray<ExtensionContextsFilter>;
  locale?: string | null;
};
export type getForgeUIExtensionsAsync_Query$data = {
  readonly extensionContexts: ReadonlyArray<{
    readonly extensions: ReadonlyArray<{
      readonly appId: string;
      readonly appOwner: {
        readonly name: string;
      } | null;
      readonly appVersion: string | null;
      readonly consentUrl: string | null;
      readonly currentUserConsent: {
        readonly appEnvironmentVersion: {
          readonly id: string;
        };
        readonly consentedAt: AGG$DateTime;
        readonly user: {
          readonly aaid: string;
        };
      } | null;
      readonly dataClassificationPolicyDecision: {
        readonly status: DataClassificationPolicyDecisionStatus;
      };
      readonly egress: ReadonlyArray<{
        readonly addresses: ReadonlyArray<string> | null;
        readonly category: AppNetworkEgressCategoryExtension | null;
        readonly inScopeEUD: boolean | null;
        readonly type: AppNetworkPermissionTypeExtension | null;
      }> | null;
      readonly environmentId: string;
      readonly environmentKey: string;
      readonly environmentType: string;
      readonly id: string;
      readonly installationConfig: ReadonlyArray<{
        readonly key: string;
        readonly value: boolean;
      }> | null;
      readonly installationId: string;
      readonly key: string;
      readonly license: {
        readonly active: boolean;
        readonly billingPeriod: string | null;
        readonly capabilitySet: CapabilitySet | null;
        readonly ccpEntitlementId: string | null;
        readonly ccpEntitlementSlug: string | null;
        readonly isEvaluation: boolean | null;
        readonly modes: ReadonlyArray<EcosystemLicenseMode> | null;
        readonly subscriptionEndDate: AGG$DateTime | null;
        readonly supportEntitlementNumber: string | null;
        readonly trialEndDate: AGG$DateTime | null;
        readonly type: string | null;
      } | null;
      readonly migrationKey: string | null;
      readonly properties: AGG$JSON;
      readonly requiresUserConsent: boolean | null;
      readonly sandboxPolicies: ReadonlyArray<string> | null;
      readonly scopes: ReadonlyArray<string>;
      readonly type: string;
      readonly userAccess: {
        readonly enabled: boolean;
        readonly hasAccess: boolean;
      } | null;
    }>;
    readonly id: string;
  }> | null;
};
export type getForgeUIExtensionsAsync_Query = {
  response: getForgeUIExtensionsAsync_Query$data;
  variables: getForgeUIExtensionsAsync_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contextIds"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "dataClassificationTags"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filter"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "locale"
},
v4 = [
  {
    "kind": "Variable",
    "name": "contextIds",
    "variableName": "contextIds"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = [
  {
    "kind": "Variable",
    "name": "filter",
    "variableName": "filter"
  },
  {
    "kind": "Variable",
    "name": "locale",
    "variableName": "locale"
  }
],
v7 = {
  "kind": "ScalarField",
  "name": "appId"
},
v8 = {
  "kind": "ScalarField",
  "name": "key"
},
v9 = {
  "kind": "ScalarField",
  "name": "name"
},
v10 = {
  "kind": "ScalarField",
  "name": "environmentId"
},
v11 = {
  "kind": "ScalarField",
  "name": "environmentType"
},
v12 = {
  "kind": "ScalarField",
  "name": "environmentKey"
},
v13 = {
  "kind": "ScalarField",
  "name": "properties"
},
v14 = {
  "kind": "ScalarField",
  "name": "type"
},
v15 = {
  "concreteType": "AppInstallationLicense",
  "kind": "LinkedField",
  "name": "license",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "active"
    },
    (v14/*: any*/),
    {
      "kind": "ScalarField",
      "name": "supportEntitlementNumber"
    },
    {
      "kind": "ScalarField",
      "name": "trialEndDate"
    },
    {
      "kind": "ScalarField",
      "name": "subscriptionEndDate"
    },
    {
      "kind": "ScalarField",
      "name": "isEvaluation"
    },
    {
      "kind": "ScalarField",
      "name": "billingPeriod"
    },
    {
      "kind": "ScalarField",
      "name": "ccpEntitlementId"
    },
    {
      "kind": "ScalarField",
      "name": "ccpEntitlementSlug"
    },
    {
      "kind": "ScalarField",
      "name": "capabilitySet"
    },
    {
      "kind": "ScalarField",
      "name": "modes"
    }
  ]
},
v16 = {
  "concreteType": "UserAccess",
  "kind": "LinkedField",
  "name": "userAccess",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "enabled"
    },
    {
      "kind": "ScalarField",
      "name": "hasAccess"
    }
  ]
},
v17 = {
  "kind": "ScalarField",
  "name": "appVersion"
},
v18 = {
  "kind": "ScalarField",
  "name": "installationId"
},
v19 = {
  "kind": "ScalarField",
  "name": "migrationKey"
},
v20 = {
  "concreteType": "EcosystemAppInstallationConfigExtension",
  "kind": "LinkedField",
  "name": "installationConfig",
  "plural": true,
  "selections": [
    (v8/*: any*/),
    {
      "kind": "ScalarField",
      "name": "value"
    }
  ]
},
v21 = {
  "concreteType": "AppNetworkEgressPermissionExtension",
  "kind": "LinkedField",
  "name": "egress",
  "plural": true,
  "selections": [
    (v14/*: any*/),
    {
      "kind": "ScalarField",
      "name": "addresses"
    },
    {
      "kind": "ScalarField",
      "name": "category"
    },
    {
      "kind": "ScalarField",
      "name": "inScopeEUD"
    }
  ]
},
v22 = {
  "kind": "ScalarField",
  "name": "sandboxPolicies"
},
v23 = {
  "kind": "ScalarField",
  "name": "scopes"
},
v24 = {
  "kind": "ScalarField",
  "name": "consentUrl"
},
v25 = {
  "concreteType": "UserConsentExtension",
  "kind": "LinkedField",
  "name": "currentUserConsent",
  "plural": false,
  "selections": [
    {
      "concreteType": "UserConsentExtensionUser",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "aaid"
        }
      ]
    },
    {
      "concreteType": "UserConsentExtensionAppEnvironmentVersion",
      "kind": "LinkedField",
      "name": "appEnvironmentVersion",
      "plural": false,
      "selections": [
        (v5/*: any*/)
      ]
    },
    {
      "kind": "ScalarField",
      "name": "consentedAt"
    }
  ]
},
v26 = {
  "kind": "ScalarField",
  "name": "requiresUserConsent"
},
v27 = {
  "args": [
    {
      "fields": [
        {
          "kind": "Variable",
          "name": "dataClassificationTags",
          "variableName": "dataClassificationTags"
        }
      ],
      "kind": "ObjectValue",
      "name": "input"
    }
  ],
  "concreteType": "DataClassificationPolicyDecision",
  "kind": "LinkedField",
  "name": "dataClassificationPolicyDecision",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "status"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "getForgeUIExtensionsAsync_Query",
    "selections": [
      {
        "args": (v4/*: any*/),
        "concreteType": "ExtensionContext",
        "kind": "LinkedField",
        "name": "extensionContexts",
        "plural": true,
        "selections": [
          (v5/*: any*/),
          {
            "args": (v6/*: any*/),
            "concreteType": "Extension",
            "kind": "LinkedField",
            "name": "extensions",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              {
                "kind": "LinkedField",
                "name": "appOwner",
                "plural": false,
                "selections": [
                  (v9/*: any*/)
                ]
              },
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v14/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/),
              (v25/*: any*/),
              (v26/*: any*/),
              (v27/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "getForgeUIExtensionsAsync_Query",
    "selections": [
      {
        "args": (v4/*: any*/),
        "concreteType": "ExtensionContext",
        "kind": "LinkedField",
        "name": "extensionContexts",
        "plural": true,
        "selections": [
          (v5/*: any*/),
          {
            "args": (v6/*: any*/),
            "concreteType": "Extension",
            "kind": "LinkedField",
            "name": "extensions",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              {
                "kind": "LinkedField",
                "name": "appOwner",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  (v9/*: any*/),
                  (v5/*: any*/)
                ]
              },
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v14/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/),
              (v25/*: any*/),
              (v26/*: any*/),
              (v27/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "f02b9eff7aa36cbdef2d023444ef3574a2ca29a78d05ea41986c50fe24bbf5e7",
    "metadata": {},
    "name": "getForgeUIExtensionsAsync_Query",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "59900f050a7e9e52914910a2298a2b90";

export default node;
